import type { GatsbyBrowser } from "gatsby"

const Root: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  // https://www.gatsbyjs.org/docs/browser-apis/#wrapRootElement
  return element
}

export default Root
